import { FC, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import * as UIConstants from "../../UIConstants";
import {
  StyledAppWrapper,
  LeftMenuSection,
  ContentWrapper,
  Content,
  LeftMenuWrapper,
  AuthContent,
} from "./StyledWrapper";
import TopBar from "../../components/AppTopbar/AppTopBar";
import { RootState } from "../../app/Store";
import { toggleLoader } from "../../features/loader";
import { useSelector, useDispatch } from "react-redux";
import { adminRouts } from "../../routs";
import Loader from "../../components/Loader/Loader";
import NetworkErrorNotifier from "../NetworkNotification/NetworkNotification";
import HumBurger from "./Humberer";
import LeftMenuMobile from "../LeftMenu/LeftMenuMobile";
import LeftMenuDesktop from "../LeftMenu/LeftmenuDesktop";
import useDimension from "../../costomHook/useDimention";

let excludeLeftMenusPath = [adminRouts.login, adminRouts];

interface AppWrapper {
  children: any;
}

const Wrapper: FC<AppWrapper> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const dimention = useDimension();

  const isLoading = useSelector(
    (state: RootState) => state.loaderslice.isLoading
  );

  let pathName = location.pathname;

  return (
    <StyledAppWrapper>
      <Loader isLoading={isLoading} />
      <NetworkErrorNotifier />
      {pathName !== "/admin/login" &&
        pathName !== "/admin/twoFa" &&
        pathName !== "/admin/forgot-password" &&
        pathName !== "/admin/reset-password" && (
          <>
            {dimention.width <= UIConstants.mobileWidth ? (
              <LeftMenuWrapper open={open}>
                <HumBurger open={open} setOpen={setOpen} />
                <LeftMenuMobile open={open} />
              </LeftMenuWrapper>
            ) : (
              <LeftMenuDesktop />
            )}
          </>
        )}
      <ContentWrapper>
        {pathName !== "/admin/login" &&
          pathName !== "/admin/twoFa" &&
          pathName !== "/admin/forgot-password" &&
          pathName !== "/admin/reset-password" && <TopBar />}
        {pathName !== "/admin/login" &&
        pathName !== "/admin/twoFa" &&
        pathName !== "/admin/forgot-password" &&
        pathName !== "/admin/reset-password" ? (
          <Content>{children}</Content>
        ) : (
          <AuthContent>{children}</AuthContent>
        )}
      </ContentWrapper>
    </StyledAppWrapper>
  );
};

export default Wrapper;
